import { render } from "./ArtworkCatalogue.vue?vue&type=template&id=76c3816d&scoped=true"
import script from "./ArtworkCatalogue.vue?vue&type=script&lang=js"
export * from "./ArtworkCatalogue.vue?vue&type=script&lang=js"

import "./ArtworkCatalogue.vue?vue&type=style&index=0&id=76c3816d&scoped=true&lang=css"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c3816d"]])

export default __exports__